var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51076 0C2.96044 0 0 2.69431 0 6.51076C0 7.96064 0.560781 9.668 1.16264 10.7907L5.89311 19.6267C5.95225 19.7394 6.04106 19.8336 6.14992 19.8994C6.25878 19.9652 6.38356 20 6.51076 20C6.63796 20 6.76274 19.9652 6.8716 19.8994C6.98046 19.8336 7.06927 19.7394 7.12841 19.6267L11.8589 10.7907C12.4607 9.66798 13.0215 7.96061 13.0215 6.51076C13.0215 2.69431 10.0611 0 6.51076 0ZM6.51076 1.39516C9.3815 1.39516 11.6264 3.39245 11.6264 6.51076C11.6264 7.56022 11.1061 9.24288 10.6308 10.1295L6.51076 17.8102L2.39067 10.1295C1.91542 9.24291 1.39516 7.56022 1.39516 6.51076C1.39516 3.39245 3.64002 1.39516 6.51076 1.39516ZM6.51076 3.25538C4.72112 3.25538 3.25538 4.72114 3.25538 6.51076C3.25538 8.30038 4.72112 9.76615 6.51076 9.76615C8.3004 9.76615 9.76614 8.30038 9.76614 6.51076C9.76614 4.72114 8.3004 3.25538 6.51076 3.25538ZM6.51076 4.65054C7.54638 4.65054 8.37098 5.47518 8.37098 6.51076C8.37098 7.54639 7.54639 8.37098 6.51076 8.37098C5.47513 8.37098 4.65054 7.54639 4.65054 6.51076C4.65054 5.47518 5.47514 4.65054 6.51076 4.65054Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.011e6c10125d51837a8ef360344175a2.svg";
export { ForwardRef as ReactComponent };